var _defs, _rect, _path, _path2, _path3, _path4, _path5, _line, _line2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLogo2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 136 152.8",
    style: {
      enableBackground: "new 0 0 136 152.8"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "myGradient",
    gradientTransform: "rotate(90)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "20%",
    stopColor: "#74d9c9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#21584f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "mySecondGradient",
    gradientTransform: "rotate(90)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "20%",
    stopColor: "#B644E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#4f1465"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -317,
    y: -29,
    width: 241,
    height: 191.5,
    fill: "url(#myGradient)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#myGradient)",
    d: "M63.1,131.7V6.6l7.8-4.2L79,70.1c0,0,2.5-6.3,20.5-7.1c29.4-0.7,25.3,15.8,27.5,43.7 c2.4,31.1-2.5,45.1-32.3,43.6c-13.4-0.7-19.1-6.7-22.2-13.2h-0.7L70,148.9l-7.6-4.1C62.3,144.8,63.1,136.1,63.1,131.7z M71.4,119.4 c0,1.8,4.5-2,4.8-0.4c4,16.6,6.1,24.9,10.5,24.9c13.1,0,17.5-18,17.5-36.9c0-18.5-4.5-36.9-17.7-36.9c-8.1,0-13.8,10.4-14.8,19.7 c-0.1,2.1,0.1,4,0.1,6.1L71.4,118V119.4z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#myGradient)",
    d: "M1,141.8c8.5-1.3,16.7-3.6,22.9-6.5c7.4-4.9,7.9-11.1,7.9-29V34.6l7.6-4.1l8.7,79.3c0,17.1-3.3,24.9-14.8,31.7 c-9.7,5.3-16.1,8.2-24.4,8.6L4.6,148L1,141.8z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#myGradient)",
    d: "M55.7,14.1c0,6.1-5.3,9.9-11.4,9.9c-5.2,0-9.7-3.6-9.7-9.7c0-5.9,3.7-10.8,11.3-11.4 C51.5,2.3,55.7,8.2,55.7,14.1z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#mySecondGradient)",
    d: "M5.2,144c8.5-1.3,19-3.1,25.1-7.8c6.6-5.3,9.1-11.8,9.1-29.8V30.5h16.3V110c0,17.1-3.3,24.9-14.8,31.7 c-9.7,5.3-24.5,8.1-32,8.5L5.2,144z M55.9,12.7c0,6.1-3,9.9-9,9.9c-5.2,0-8.6-3.8-8.6-9.9c0-5.9,3.4-9.9,9-9.9 C52.9,2.7,55.9,6.8,55.9,12.7z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#mySecondGradient)",
    d: "M69.9,149c0.2-3.2,0.9-12.9,0.9-17.3V2.4h18l-0.1,64.8c0,0,7.4-4.1,16.1-4.1c14.9,0,30,12.8,30,43.6 c0,31.2-17.5,43.6-32.3,43.6c-13.4,0-19.1-6.7-22.2-13.2h-0.7l-0.9,11.8h-8.6v0.1L69.9,149L69.9,149z M78.3,119.5 c0,1.8,0,3.5,0.3,5.2c4,16.6,11.5,19.2,15.9,19.2c13.1,0,17.5-18,17.5-36.9c0-18.5-4.5-36.9-17.7-36.9c-8.1,0-14.8,10.4-15.8,19.8 c-0.1,2.1-0.1,4-0.1,6.1L78.3,119.5L78.3,119.5z"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: -15.2,
    y1: 153.3,
    x2: 1.2,
    y2: 162
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: -15.6,
    y1: 146.5,
    x2: -6.3,
    y2: 162.5
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo2);
export default __webpack_public_path__ + "static/media/logo2.7cc14f6847da9bc50b7d3df8a8748386.svg";
export { ForwardRef as ReactComponent };